<script lang="ts">
/**
 * @component PinnedProjects
 *
 * Displays the portfolio's pinned (featured) projects in a responsive masonry
 * grid.
 * ...
 */
import * as ProjectCard from "$lib/components/project-card";
import { Pin, Loader2 } from "@lucide/svelte";
import { t, locale } from "$lib/i18n";
import { cn } from "$lib/utils";

import { page } from "$app/state";
let projects = $derived(page.data.pinnedProjects || []);
</script>

<div class={cn("w-full px-4 space-y-6")}>
  <h2
    class={cn(
      "text-3xl md:text-4xl font-bold text-center flex items-center justify-center gap-3",
    )}
  >
    <Pin class={cn("w-7 h-7 text-primary")} />
    {$t("projects.pinned")}:
  </h2>
  <div class={cn("grid grid-cols-1 gap-5")}>
    {#each projects as project (project.key)}
      <ProjectCard.Root
        projektImage={project.image}
        projektImageAlt={project.translatedImgAlt}
        projektImageBgColor={project.bgColor}
        projektTitle={project.translatedTitle}
        projektBadges={project.badges}
        projektLink={project.link}
      >
        {#snippet children()}{project.translatedDescription}{/snippet}
      </ProjectCard.Root>
    {/each}
  </div>
</div>
